/* eslint-disable import/prefer-default-export */

import { delay } from 'redux-saga';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { updateGridScrollPosition } from '../actions/UIActions';
import { searchImagesNextPage } from '../actions/SearchFieldActions';

function* doHandleGridScrollPositionChange({ payload }) {
  yield call(delay, 20);
  const { scrollTop, scrollHeight, offsetHeight } = payload;
  yield put(updateGridScrollPosition(scrollTop));

  const { SearchField: state } = yield select();
  const {
    imagesSearchResult: { totalPage, currentPage },
    searching,
    error: { type: errType }
  } = state;

  /*
   *  If currently searching or error occurred, or there isn't exist
   *  next page, then stop searching process
   */
  if (searching || errType || totalPage === currentPage) {
    return;
  }

  const bottomDistance = scrollHeight - scrollTop - offsetHeight;
  if (bottomDistance < offsetHeight * 0.5) {
    yield put(searchImagesNextPage());
  }
}

export function* infiniteScrollExperience() {
  yield takeLatest('GRID_SCROLL_POSITION_CHANGE', doHandleGridScrollPositionChange);
}



// WEBPACK FOOTER //
// ./src/sagas/UISaga.js